export default {
  // Options.jsx
  items_per_page: '/ sah.',
  jump_to: 'O\'tish',
  jump_to_confirm: 'tasdiqlash',
  page: 'Sahifa',
  // Pagination.jsx
  prev_page: 'Orqaga',
  next_page: 'Oldinga',
  prev_5: 'Oldingi 5',
  next_5: 'Keyingi 5',
  prev_3: 'Oldingi 3',
  next_3: 'Keyingi 3',
  page_size: 'sahifa hajmi'
};